import { useNavigate } from "@tanstack/react-router";
import { ConnectionForm } from "@/components/entity-tabs/connections-tab/connection-form";
import type { ConnectionItem } from "@/lib/api/connections";

export function ConnectionCreate({
	ownerSlug,
	organizationId,
	connections,
	initialConnectorKey,
}: {
	ownerSlug: string;
	organizationId: string;
	connections: ConnectionItem[];
	initialConnectorKey?: string;
}) {
	const navigate = useNavigate();
	return (
		<ConnectionForm
			onCreated={(connectionId, connectorKey) => {
				void navigate({
					to: "/$owner/connectors/$connectorKey/$connectionId",
					params: {
						owner: ownerSlug,
						connectorKey,
						connectionId: String(connectionId),
					},
					search: {},
				});
			}}
			onClose={() => {
				void navigate({
					to: "/$owner/connectors",
					params: { owner: ownerSlug },
				});
			}}
			organizationId={organizationId}
			connections={connections}
			initialConnectorKey={initialConnectorKey}
			ownerSlug={ownerSlug}
			onDeepLinkBack={
				initialConnectorKey
					? () => {
							void navigate({
								to: "/$owner/connectors/create",
								params: { owner: ownerSlug },
							});
						}
					: undefined
			}
		/>
	);
}
